<template>
    <div class="benzol">
        <ul>
            <li>Mesomere Grenzstruktur</li>
            <li>C<sub>6</sub>H<sub>6</sub></li>
        </ul>
        <img
            src="@/assets/img/stoffe/aromaten/benzol.png"
            alt="Gängige Darstellung von Benzol"
            title="Gängige Darstellung von Benzol"
        />
    </div>
</template>

<script>
export default {
    name: 'benzol',
};
</script>
